// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3MLOU","clinicsSelect":"styles_clinicsSelect__TSrVK"};